import { useGetTranscriptionQuery } from '@/core/services/transcription'
import { Typography } from '@mui/material'
import { Box, Stack } from '@mui/system'
import { Trans } from '@lingui/macro'

type TranscriptionViewerProps = {
  transcriptionId: string
}

export function TranscriptionViewer({ transcriptionId }: TranscriptionViewerProps) {
  const { data: transcription } = useGetTranscriptionQuery(transcriptionId, { refetchOnMountOrArgChange: true })
  return (
    <Box sx={{ height: '100%', p: 2 }}>
      <Typography variant="h6" gutterBottom>
        <Trans>Transcription</Trans>
      </Typography>
      <Stack spacing={2}>
        {transcription?.segments.map((segment, index) => (
          <Stack key={index} spacing={1} sx={{ pb: 1 }}>
            <Typography variant="caption" color="textSecondary">
              {segment.start} - {segment.end}
            </Typography>
            <Typography variant="body1">{segment.text}</Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  )
}
